/**
 * Custom icon list
 * All icons are loaded here for easy management
 * @see https://vue.ant.design/components/icon/#Custom-Font-Icon
 *
 * 自定义图标加载表
 * 所有图标均从这里加载，方便管理
 */
// import bxAnaalyse from "@/assets/icons/bx-analyse.svg?inline"; // path to your '*.svg?inline' file.
import iconAll from "@/assets/icons/icon_all.svg?inline";
import iconCheck from "@/assets/icons/icon_check.svg?inline";
import iconHome from "@/assets/icons/icon_home.svg?inline";
import iconIssue from "@/assets/icons/icon_issue.svg?inline";
import iconList from "@/assets/icons/icon_list.svg?inline";
import iconStatistical from "@/assets/icons/icon_statistical.svg?inline";
import iconTeacher from "@/assets/icons/icon_teacher.svg?inline";
import iconUpload from "@/assets/icons/icon_upload.svg?inline";

const icons = {
  iconAll,
  iconCheck,
  iconHome,
  iconIssue,
  iconList,
  iconStatistical,
  iconTeacher,
  iconUpload
};
export { icons };
